export const PHONE_NUMBER = `1-833-MyBV-360 (833-692-8360)`;
export const FAX_NUMBER = `1-833-MyBV-FAX (833-692-8329)`;
export const ESCALATION_EMAIL = 'reprisebio.com';

export const dataSitofCare = [
  {
    name: "Physician Office (POS 11)",
    value: "Physician Office (POS 11)",
  },
  {
    name: "Home (POS 12)",
    value: "Home (POS 12)",
  },
  {
    name: "In Patient (POS 21)",
    value: "In Patient (POS 21)",
  },
  {
    name: "Hospital Outpatient (POS 22)",
    value: "Hospital Outpatient (POS 22)",
  },
  {
    name: "Ambulatory Surgical Center (POS 24)",
    value: "Ambulatory Surgical Center (POS 24)",
  },
  {
    name: "Skilled Nursing Facility (POS 31)",
    value: "Skilled Nursing Facility (POS 31)",
  },
  {
    name: "Nursing Facility (POS 32)",
    value: "Nursing Facility (POS 32)",
  },
  {
    name: "Other",
    value: "other",
  },
];
